import React from "react"
import innovid from "../../images/brand-logos/innovid-dark-blue.svg"
import cint from "../../images/brand-logos/cint-dark-blue.svg"
import placeiq from "../../images/brand-logos/placeiq-dark-blue.svg"
import dv360 from "../../images/brand-logos/dv360-dark-blue.svg"
import kantar from "../../images/brand-logos/kantar-dark-blue.svg"
import adelaide from "../../images/brand-logos/adelaide-dark-blue.svg"
import index from "../../images/brand-logos/index-dark-blue.svg"
import ttd from "../../images/brand-logos/ttd-dark-blue.svg"
import viant from "../../images/brand-logos/viant-dark-blue.svg"
import appsFlyer from "../../images/brand-logos/apps-flyer-dark-blue.svg"
import adjust from "../../images/brand-logos/adjust-dark-blue.svg"
import kochava from "../../images/brand-logos/kochava-dark-blue.svg"
import branch from "../../images/brand-logos/branch-dark-blue.svg"
import singular from "../../images/brand-logos/singular-dark-blue.svg"
import upwave from "../../images/brand-logos/upwave-dark-blue.svg"
import liverampDarkBlue from "../../images/brand-logos/liveramp-dark-blue.svg"
import { OutcomeCardGrid } from "./outcome-card-grid"
import "../../styles/outcome-section.scss"

const cards = [
  {
    logo: [kantar, upwave, cint],
    title: "Brand Lift",
    description: "Drive stronger brand recall and favorability.",
    gradient:
      "radial-gradient(at 90% 8%, #7697f0 0%,#c2ddfb 40%, #def9ff 100%)",
    href: "/solutions/brand-lift",
  },
  {
    title: "Search Lift",
    description: "Turn passive viewers into active searchers.",
    gradient:
      "radial-gradient(at 0% 2%, rgb(118, 151, 240) 0%, rgb(213, 228, 249) 62%)",
    href: "/solutions/search-lift",
  },
  {
    logo: placeiq,
    title: "Store Visits",
    description: "Drive verified foot traffic with precision.",
    gradient:
      "radial-gradient(at 0% 0%, rgb(222 231 255) 0%, rgb(201 210 251 / 81%) 60%)",
    href: "/solutions/store-visits",
  },
  {
    logo: [appsFlyer, adjust, kochava, branch, singular],
    title: "App Subscriptions",
    description: "Drive installs that lead to real value.",
    gradient:
      "linear-gradient(to bottom right, rgb(201 209 251 / 81%) 50% , #a6d9f6 100%)",
    href: "/solutions/app-subscriptions",
  },
  {
    logo: liverampDarkBlue,
    logoAlt: "LiveRamp",
    logoScale: 0.85,
    title: "Customer Value",
    description: "Grow customer value beyond the first conversion.",
    gradient: "rgb(222 243 255)",
    href: "/solutions/customer-value",
  },
  {
    logo: adelaide,
    title: "Attention",
    description: "Capture more qualified leads, faster.",
    gradient:
      "radial-gradient(at 80% 100%, rgb(159, 163, 228) -2%, rgb(222 238 255) 45%)",
    href: "/solutions/attention",
  },
  {
    logo: [index, dv360, ttd, viant],
    title: "Engagement",
    description: "Drive Engagement with Sell-Side AI Decisioning.",
    gradient:
      "radial-gradient(at 0% 90%, rgb(159, 163, 228) -11%, rgb(222, 230, 255) 23%)",
    href: "/solutions/engagement",
  },
  {
    logo: [index, dv360, ttd, viant],
    title: "Efficient Reach",
    description: "Deliver Efficient Reach with Sell-Side AI Decisioning.",
    gradient:
      "linear-gradient(90deg, rgba(201, 209, 251, 0.81) 52%, rgb(166, 217, 246) 100%)",
    href: "/solutions/efficient-reach",
  },
]

export default function OutcomeSection({ showDescription = true }) {
  return (
    <section>
      {showDescription ? (
        <>
          <hr className="divider" />
          <div className="container py-6 px-5 outcome-container is-flex is-flex-direction-column">
            <h1 className="title text-dark-blue is-size-1-desktop">
              Proven Outcomes. <br /> Powered by Sell-Side AI Decisioning.
            </h1>
            <div className="outcome-subtitle">
              <p className="text-dark-blue has-text-weight-semibold mb-2">
                Optimize for real business outcomes - at scale and in real time.
              </p>
              <p className="text-dark-blue">
                From brand lift to customer value, inPowered AI’s PMP deals
                deliver measurable outcomes through impression-level decisioning
                trained on data from Kantar, Cint, EDO, Innovid, PlaceIQ,
                Adelaide, plus your own first party data.
              </p>
            </div>
            <OutcomeCardGrid items={cards} />
          </div>
        </>
      ) : (
        <OutcomeCardGrid items={cards} />
      )}
    </section>
  )
}
